<template>
    <div class="info">
        <h4>{{ v.title }}</h4>
        <HomeLazyImage :src="BASE_URL+v.img" :alt="v.title"/>
        <p>
            محتویات پکیج شامل:
            <ul>
                <li v-for="b in v.details" :key="b.m">
                {{ 
                    b.t>0?b.t+' عدد سفته '+
                    (b.m==1000?
                        ' یک میلیارد تومانی':
                        (b.m==2000?
                        ' دو میلیارد تومانی':
                        b.m+' میلیون تومانی'
                    ))
                    :'-'
                }}
                </li>
            </ul>
            <small>تعداد کل:{{ v.counts }} عدد</small>
            <br>
            <small>ارزش کل:
            {{ v.description }}
            </small>
            <br>
            <strong>قیمت {{ formatPrice(v.price) }}</strong>
            <button v-if="t" type="button" class="payPack" @click="payPack(v.id)" :disabled="disBtn">{{ t }}</button>
        </p>
    </div>
</template>
<script setup>
    import HomeLazyImage from '@/components/tooles/lazy/HomeLazyImage.vue';
    import { BASE_URL } from '@/config';    
    import { defineProps , computed , defineEmits, ref } from 'vue';
    const disBtn = ref(false)
    const formatPrice = (price) => {
        if (!price && price !== 0) return '-'
        return new Intl.NumberFormat('fa-IR').format(price) + ' تومان'
    };
    const props = defineProps({
        data:{
            type:Object,
            default:null
        },
        btnName:{
            type:String,
            default:''
        }
    })
    const v = computed(()=>{return props.data})
    const t = computed(()=>{return props.btnName})
    const emit=defineEmits('pay');
    const payPack = (id)=>{
        disBtn.value=true
        emit('pay',id)
    }
</script>
<style scoped>
    .info{
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: nowrap;
        justify-content: space-evenly;
        padding: 10px;
        box-sizing: border-box;
        background: #4f3737ad;
        border-radius: 15px;
    }
    .info ul{
        list-style: none;
        padding: 0;
    }
    .payPack {
        width: 100%;
        margin-top: 10px;
        padding: 10px 0;
        outline: none;
        border: none;
        color: white;
        border-radius: 5px;
        background: green;
        cursor: pointer;
    }
    img{
        width:100%;
        height:220px;
        object-fit:cover;
        border-radius:16px;
        opacity:0;
        transition: opacity .6s ease;
    }
    img.loaded {
        opacity:1;
    }
</style>